export default __webpack_public_path__ + "static/media/sarah_drinks.1fb0d9ce.gif";